// MAC address helpers. Standard format: 6 hex pairs, colon-separated, lowercase.
// Example: 49:78:2d:63:87:d9
export function formatMac(value) {
  const hex = (value || "").replace(/[^a-fA-F0-9]/g, "").toLowerCase().slice(0, 12);
  return hex.match(/.{1,2}/g)?.join(":") || "";
}

export function isCompleteMac(value) {
  return /^[0-9a-f]{2}(:[0-9a-f]{2}){5}$/.test((value || "").toLowerCase());
}
